
import { Button } from "@/components/ui/button";
import { Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

interface EditButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const EditButton: React.FC<EditButtonProps> = ({ onClick, disabled }) => {
  return (
    <Tooltip title="Edit message">
      <Button
        sx={{
          textTransform: "capitalize",
          fontSize: "0.25rem",
        }}
        variant={"outline"}
        onClick={onClick}
        disabled={disabled}
        startIcon={<EditIcon />}
        className={`text-xs p-2 ml-2`}
      >
        Edit Message
      </Button>
    </Tooltip>
  );
};

export default EditButton;
